// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    socketIoConfig: {
        url: `${window.location.host}`,
        options: {}
    },
    targetUri: (uri: string) => {
        return uri;
    },
    api: 'https://syval-agrement-backend-development-mdigvbfbpa-ew.a.run.app',
    //api: '/api',
    firebase: {
        apiKey: "AIzaSyCbJUx1bPBPux6ZQL6wvR15g1C5GuifxJk",
        authDomain: "sudcontractors.firebaseapp.com",
        databaseURL: "https://sudcontractors.firebaseio.com",
        projectId: "sudcontractors",
        storageBucket: "sudcontractors.appspot.com",
        messagingSenderId: "982477354612",
        appId: "1:982477354612:web:9325ad20308fbacc1e4321",
        measurementId: "G-Z9R0Y28GT4"
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
